// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/SourceSansPro-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/SourceSansPro-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/SourceSansPro-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/SourceSansPro-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/SourceSansPro-It.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/ElsevierSansWeb-Regular_reduced.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 200;

  src: local('Source Sans Pro ExtraLight'), local('SourceSansPro-ExtraLight'),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      format('truetype');
}
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 300;

  src: local('Source Sans Pro Light'), local('SourceSansPro-Light'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
      format('truetype');
}
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;

  src: local('Source Sans Pro'), local('SourceSansPro-Regular'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___})
      format('truetype');
}
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 700;

  src: local('Source Sans Pro Bold'), local('SourceSansPro-Bold'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___})
      format('truetype');
}
@font-face {
  font-family: 'Source Sans Pro';
  font-style: italic;
  font-weight: 400;

  src: local('Source Sans Pro Italic'), local('SourceSansPro-It'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___})
      format('truetype');
}

@font-face {
  font-family: 'Elsevier Sans';
  font-style: normal;
  font-weight: 400;

  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2');
}

html {
  font-family: 'Elsevier Sans', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/fonts.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;;EAEhB;;wBAEsB;AACxB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;;EAEhB;;wBAEsB;AACxB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;;EAEhB;;wBAEsB;AACxB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;;EAEhB;;wBAEsB;AACxB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;;EAEhB;;wBAEsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;;EAEhB,4DAAuE;AACzE;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["@font-face {\n  font-family: 'Source Sans Pro';\n  font-style: normal;\n  font-weight: 200;\n\n  src: local('Source Sans Pro ExtraLight'), local('SourceSansPro-ExtraLight'),\n    url(./fonts/SourceSansPro-ExtraLight.ttf)\n      format('truetype');\n}\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-style: normal;\n  font-weight: 300;\n\n  src: local('Source Sans Pro Light'), local('SourceSansPro-Light'),\n    url(./fonts/SourceSansPro-Light.ttf)\n      format('truetype');\n}\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-style: normal;\n  font-weight: 400;\n\n  src: local('Source Sans Pro'), local('SourceSansPro-Regular'),\n    url(./fonts/SourceSansPro-Regular.ttf)\n      format('truetype');\n}\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-style: normal;\n  font-weight: 700;\n\n  src: local('Source Sans Pro Bold'), local('SourceSansPro-Bold'),\n    url(./fonts/SourceSansPro-Bold.ttf)\n      format('truetype');\n}\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-style: italic;\n  font-weight: 400;\n\n  src: local('Source Sans Pro Italic'), local('SourceSansPro-It'),\n    url(./fonts/SourceSansPro-It.ttf)\n      format('truetype');\n}\n\n@font-face {\n  font-family: 'Elsevier Sans';\n  font-style: normal;\n  font-weight: 400;\n\n  src: url(./fonts/ElsevierSansWeb-Regular_reduced.woff2) format('woff2');\n}\n\nhtml {\n  font-family: 'Elsevier Sans', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
